import { render, staticRenderFns } from "./name.vue?vue&type=template&id=356e3de6&scoped=true&"
import script from "./name.vue?vue&type=script&lang=js&"
export * from "./name.vue?vue&type=script&lang=js&"
import style0 from "./name.vue?vue&type=style&index=0&id=356e3de6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e3de6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('356e3de6')) {
      api.createRecord('356e3de6', component.options)
    } else {
      api.reload('356e3de6', component.options)
    }
    module.hot.accept("./name.vue?vue&type=template&id=356e3de6&scoped=true&", function () {
      api.rerender('356e3de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/field-template/name.vue"
export default component.exports